import {getDictionaries, shareDataSetGrant, requestAllPermissions, revokePermissionRequest} from "./api";

export const DICTIONARY_LOADING = "DICTIONARY_LOADING"
export const DICTIONARY_LOADED = "DICTIONARY_LOADED"
export const DICTIONARY_LOADED_ERROR = "DICTIONARY_LOADED_ERROR"

export const SHARE_DATE_SEND = "SHARE_DATE_SEND"
export const SHARE_DATE_ACKNOWLEDGE = "SHARE_DATE_ACKNOWLEDGE"
export const SHARE_DATA_ERROR = "SHARE_DATA_ERROR"

export const PERMISSIONS_REQUEST = "PERMISSIONS_REQUEST"
export const PERMISSIONS_RECEIVED = "PERMISSIONS_RECEIVED"
export const PERMISSIONS_RECEIVED_ERROR = "PERMISSIONS_RECEIVED_ERROR"

export const PERMISSIONS_REVOKE = "PERMISSIONS_REVOKE"
export const PERMISSIONS_REVOKE_OK = "PERMISSIONS_REVOKE_OK"
export const PERMISSIONS_REVOKE_ERROR = "PERMISSIONS_REVOKE_ERROR"

export function requestPermissions() {
    return function (dispatch, getState) {
        const token = getState().user.token;
        if (!token) {
            return Promise.reject()
        }

        dispatch(permissionsRequest())

        requestAllPermissions(token)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Response is not OK")
                }
                return response
            })
            .then(response => response.json())
            .then(response => dispatch(permissionRecieved(response)))
            .catch(() => dispatch(permissionsRecievedError()))
    }
}

export function permissionsRequest() {
    return {
        type: PERMISSIONS_REQUEST
    }
}

function permissionRecieved(permissionsListReceived) {
    return {
        type: PERMISSIONS_RECEIVED,
        permissionsListReceived
    }
}

function permissionsRecievedError() {
    return {
        type: PERMISSIONS_RECEIVED_ERROR
    }
}

export function requestDictionaries() {
    return function (dispatch, getState) {
        const token = getState().user.token;
        if (!token) {
            return Promise.reject()
        }

        dispatch(loadDictionaries())

        getDictionaries(token)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Response is not OK")
                }
                return response
            })
            .then(response => response.json())
            .then(dictionaries => dispatch(updateDictionaries(dictionaries)))
            .catch(() => dispatch(dictionaryLoadedError()))
    }
}

export function loadDictionaries() {
    return {
        type: DICTIONARY_LOADING
    
    }
}

function updateDictionaries(dictionaries) {
    return {
        type: DICTIONARY_LOADED,
        dictionaries
    }
}

function dictionaryLoadedError() {
    return {
        type: DICTIONARY_LOADED_ERROR
    }
}

export function sendShareDataRequest(spId, serialNumber, address, dateFrom, dateTo, direction, product, email, phone, purpose, expirationDate) {
    return function (dispatch, getState) {
        const token = getState().user.token;
        if (!token) {
            return Promise.reject()
        }

        const request = {
            spId,
            serialNumber,
            address,
            startDate: dateFrom.toISOString(),
            endDate: dateTo.toISOString(),
            direction, 
            product, 
            email,
            phone,
            purpose, 
            expirationDate: expirationDate.toISOString()
        }

        dispatch(sendShareData())

        shareDataSetGrant(request, token)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Response is not OK")
                }
                return response
            })
            .then(response => response.json())
            .then(response => dispatch(recieveResponseShareData(response)))
            .catch(() => dispatch(errorShareData()))
    }
}

export function sendShareData() {
    return {
        type: SHARE_DATE_SEND
    }
}

function recieveResponseShareData(acknowledge) {
    return {
        type: SHARE_DATE_ACKNOWLEDGE,
        acknowledge
    }
}

function errorShareData() {
    return {
        type: SHARE_DATA_ERROR
    }
}

export function revokePermission(shareDataId) {
    return function (dispatch, getState) {
        const token = getState().user.token;
        if (!token) {
            return Promise.reject()
        }

        const request = {
            shareDataId
        }

        dispatch(revokePermissionSended())

        revokePermissionRequest(request, token)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Response is not OK")
                }
                return response
            })
            .then(response => response.json())
            .then(response => dispatch(revokePermissionOk(shareDataId, response)))
            .catch(() => dispatch(revokePermissionError()))
    }
}

export function revokePermissionSended() {
    return {
        type: PERMISSIONS_REVOKE
    }
}

function revokePermissionOk(shareDataId, response) {
    const newExpirationDate = response.newExpirationDate
    const newStatus = response.newStatus
    return {
        type: PERMISSIONS_REVOKE_OK,
        shareDataId,
        newExpirationDate,
        newStatus
    }
}

function revokePermissionError() {
    return {
        type: PERMISSIONS_REVOKE_ERROR
    }
}
